import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.graph.line');
import { OnInit, OnChanges, OnDestroy, Input, SimpleChanges, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Chart } from 'chart.js/auto';

@Component({
    selector: 'wiz-component-graph-line',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.graph.line/view.scss */
:host {
  display: block;
  width: 100%;
  min-width: 0;
}`],
})
export class ComponentGraphLineComponent implements OnInit, OnChanges, OnDestroy {

    @Input() data: {
        labels: string[];
        datasets: any[];
    } | null = null;

    public isEmpty: boolean = true;

    private chart?: Chart;

    constructor(@Inject( ElementRef) private el: ElementRef,@Inject( ChangeDetectorRef)  private cdr: ChangeDetectorRef) {}

    ngOnInit() {
    }

    ngOnDestroy() {
        this.chart?.destroy();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['data']) {
            if (!this.data || !this.data.labels || this.data.labels.length === 0) {
                this.isEmpty = true;
                if (this.chart) {
                    this.chart.destroy();
                    this.chart = undefined;
                }
                return;
            }
            this.isEmpty = false;
            this.cdr.detectChanges();
            setTimeout(() => this.renderChart());
        }
    }

    private renderChart() {

        if (!this.data) return;

        const canvas = this.el.nativeElement.querySelector('canvas') as HTMLCanvasElement | null;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        this.chart?.destroy();

        const customOptions = (this.data as any).options;
        const baseOptions: any = {
            responsive: true,
            maintainAspectRatio: false,
            interaction: { mode: 'index' as const, intersect: false },
            elements: {
                point: { radius: 0, hoverRadius: 5, hoverBorderWidth: 2 },
                line: { borderWidth: 2.5, tension: 0.4 }
            },
            plugins: {
                legend: {
                    position: 'top' as const,
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'circle',
                        padding: 20,
                        font: { size: 13 }
                    }
                },
                tooltip: {
                    backgroundColor: '#141414',
                    titleFont: { size: 13 },
                    bodyFont: { size: 12 },
                    padding: 12,
                    cornerRadius: 8,
                    displayColors: true,
                    usePointStyle: true
                }
            },
            scales: {
                x: {
                    grid: { color: 'rgba(107,114,128,0.08)' },
                    ticks: { font: { size: 12 }, color: '#6b7280' }
                },
                y: {
                    grid: { color: 'rgba(107,114,128,0.08)' },
                    ticks: { font: { size: 12 }, color: '#6b7280' }
                }
            }
        };
        const options = customOptions
            ? this.deepMerge(baseOptions, customOptions)
            : baseOptions;

        this.chart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: this.data.labels,
                datasets: this.data.datasets
            },
            options
        });
    }

    private deepMerge(target: any, source: any): any {
        const result = { ...target };
        for (const key of Object.keys(source)) {
            if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])
                && target[key] && typeof target[key] === 'object' && !Array.isArray(target[key])) {
                result[key] = this.deepMerge(target[key], source[key]);
            } else {
                result[key] = source[key];
            }
        }
        return result;
    }
}

export default ComponentGraphLineComponent;